export enum CountryCode {
  KZ = 'kz',
  RU = 'ru',
  UZ = 'uz',
  KG = 'kg',
  TM = 'tm',
  BY = 'by',
}
